/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import api from "_config/api";

export type PostOuvidoriaEssencial = {
  id: string;
  titulo: string;
  descricao: string;
  endereco: {
    tipoLogradouro: string;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    municipio: string;
    uf: string;
    cep: string;
  };
};

export interface GetEssentialServicesGeojsonRequest {
  search?: string;
  onSuccess?: (data: PostOuvidoriaEssencial) => void;
}

interface State {
  isRequesting: boolean;
  successPayload: GeoJSON.FeatureCollection<
    GeoJSON.Point,
    PostOuvidoriaEssencial
  > | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const getEssentialServicesGeojsonSlice = createSlice({
  name: "ouvidoria.pontosessenciais@getEssentialServicesGeojson",
  initialState,
  reducers: {
    getEssentialServicesGeojsonRequest: (
      state,
      _action: PayloadAction<GetEssentialServicesGeojsonRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    getEssentialServicesGeojsonSuccess: (
      state,
      action: PayloadAction<
        GeoJSON.FeatureCollection<GeoJSON.Point, PostOuvidoriaEssencial>
      >
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getEssentialServicesGeojsonFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: GetEssentialServicesGeojsonRequest;
}) {
  try {
    const { onSuccess, search } = params.payload;

    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      "api/v1/cidadao/ouvidoria/pontosessenciais/geojson",
      {
        params: {
          search
        }
      }
    );

    if (onSuccess) onSuccess(response.data);

    yield put(getEssentialServicesGeojsonSuccess(response.data));
  } catch (error) {
    yield put(getEssentialServicesGeojsonFailed([]));
  }
}

export const {
  getEssentialServicesGeojsonFailed,
  getEssentialServicesGeojsonRequest,
  getEssentialServicesGeojsonSuccess
} = getEssentialServicesGeojsonSlice.actions;

export const { reducer } = getEssentialServicesGeojsonSlice;
export const saga = takeLatest(
  getEssentialServicesGeojsonRequest.type,
  sagaFunction
);
